(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const faqItems = document.querySelectorAll('.faq-accordion__item');
    
    faqItems.forEach(item => {
      const button = item.querySelector('[data-faq-toggle]');
      const answer = item.querySelector('.faq-accordion__answer');
      
      if (!button || !answer) return;
      
      button.addEventListener('click', function() {
        const isExpanded = item.getAttribute('aria-expanded') === 'true';
        
        // Toggle current item
        item.setAttribute('aria-expanded', !isExpanded);
        answer.setAttribute('aria-hidden', isExpanded);
        button.setAttribute('aria-expanded', !isExpanded);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-toc"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var nav = document.querySelector('[data-floating-toc]');
    if (!nav) return;
    if (window.matchMedia('(max-width: 1023px)').matches) return;

    var tab = nav.querySelector('[data-floating-toc-tab]');
    var links = nav.querySelectorAll('.floating-toc__link');
    var mq = window.matchMedia('(max-width: 1023px)');

    function closeToc() {
      nav.classList.remove('floating-toc--expanded');
      nav.setAttribute('aria-expanded', 'false');
    }

    function openToc() {
      nav.classList.add('floating-toc--expanded');
      nav.setAttribute('aria-expanded', 'true');
    }

    function handleLinkClick(e) {
      var link = e.currentTarget;
      var href = link.getAttribute('href');
      if (href && href.indexOf('#') === 0 && link.hasAttribute('data-anchor-link')) {
        e.preventDefault();
        var id = href.slice(1);
        var target = document.getElementById(id);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          closeToc();
        }
      }
      /* Page links navigate normally; close TOC on mobile */
      if (nav.classList.contains('floating-toc--expanded')) {
        closeToc();
      }
    }

    function handleTabClick(e) {
      if (mq.matches) {
        e.preventDefault();
        if (nav.classList.contains('floating-toc--expanded')) {
          closeToc();
        } else {
          openToc();
        }
      }
    }

    function handleTabKeydown(e) {
      if (!mq.matches) return;
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        handleTabClick(e);
      }
    }

    if (tab) {
      tab.addEventListener('click', handleTabClick);
      tab.addEventListener('keydown', handleTabKeydown);
    }

    links.forEach(function(link) {
      link.addEventListener('click', handleLinkClick);
    });

    mq.addEventListener('change', function() {
      if (!mq.matches) closeToc();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    const header = document.querySelector('[data-header]');
    if (!header) return;

    const mobileMenuToggle = header.querySelector('[data-mobile-menu-toggle]');
    const mobileMenu = header.querySelector('[data-mobile-menu]');
    const menuIconOpen = header.querySelector('[data-menu-icon-open]');
    const menuIconClose = header.querySelector('[data-menu-icon-close]');
    const mobileNavLinks = header.querySelectorAll('[data-mobile-nav-link]');
    const mobileNavToggles = header.querySelectorAll('[data-mobile-nav-toggle]');
    const navItemsWithDropdown = header.querySelectorAll('.header__nav-item[data-has-dropdown]');
    const DROPDOWN_HIDE_DELAY_MS = 180;

    // Desktop dropdown: hover with delay before closing so users can move to submenu
    navItemsWithDropdown.forEach(function(navItem) {
      var closeTimer = null;

      function openDropdown() {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
        navItem.setAttribute('data-dropdown-open', '');
      }

      function closeDropdown() {
        closeTimer = setTimeout(function() {
          navItem.removeAttribute('data-dropdown-open');
          closeTimer = null;
        }, DROPDOWN_HIDE_DELAY_MS);
      }

      navItem.addEventListener('mouseenter', openDropdown);
      navItem.addEventListener('mouseleave', closeDropdown);
    });

    // Mobile menu toggle
    if (mobileMenuToggle && mobileMenu) {
      mobileMenuToggle.addEventListener('click', function() {
        const isOpen = mobileMenu.hasAttribute('data-mobile-menu-open');

        if (isOpen) {
          mobileMenu.removeAttribute('data-mobile-menu-open');
          mobileMenuToggle.setAttribute('aria-expanded', 'false');
          menuIconOpen?.removeAttribute('hidden');
          menuIconClose?.setAttribute('hidden', '');
          header.querySelectorAll('.header__mobile-nav-item[data-mobile-subnav-open]').forEach(function(item) {
            item.removeAttribute('data-mobile-subnav-open');
          });
          mobileNavToggles.forEach(function(t) {
            t.setAttribute('aria-expanded', 'false');
          });
        } else {
          mobileMenu.setAttribute('data-mobile-menu-open', '');
          mobileMenuToggle.setAttribute('aria-expanded', 'true');
          menuIconOpen?.setAttribute('hidden', '');
          menuIconClose?.removeAttribute('hidden');
        }
      });
    }

    // Mobile submenu toggles (including nested)
    mobileNavToggles.forEach(function(toggle) {
      toggle.addEventListener('click', function(e) {
        e.stopPropagation();
        const navItem = this.closest('.header__mobile-nav-item');
        if (!navItem) return;
        const isOpen = navItem.hasAttribute('data-mobile-subnav-open');

        if (isOpen) {
          navItem.removeAttribute('data-mobile-subnav-open');
          this.setAttribute('aria-expanded', 'false');
        } else {
          navItem.setAttribute('data-mobile-subnav-open', '');
          this.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // Close mobile menu when clicking a link
    mobileNavLinks.forEach(function(link) {
      link.addEventListener('click', function() {
        if (mobileMenu) {
          mobileMenu.removeAttribute('data-mobile-menu-open');
          if (mobileMenuToggle) {
            mobileMenuToggle.setAttribute('aria-expanded', 'false');
          }
          if (menuIconOpen) menuIconOpen.removeAttribute('hidden');
          if (menuIconClose) menuIconClose.setAttribute('hidden', '');
        }
      });
    });

    // Search overlay
    const searchToggle = header.querySelector('[data-search-toggle]');
    const searchOverlay = header.querySelector('[data-search-overlay]');
    const searchInput = header.querySelector('[data-search-input]');
    const searchCloseButtons = header.querySelectorAll('[data-search-close]');

    function openSearch() {
      if (searchOverlay) {
        searchOverlay.setAttribute('data-search-open', '');
        searchOverlay.setAttribute('aria-hidden', 'false');
        if (searchInput) {
          searchInput.focus();
        }
        document.body.style.overflow = 'hidden';
      }
    }

    function closeSearch() {
      if (searchOverlay) {
        searchOverlay.removeAttribute('data-search-open');
        searchOverlay.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        if (searchToggle) searchToggle.focus();
      }
    }

    if (searchToggle && searchOverlay) {
      searchToggle.addEventListener('click', openSearch);
    }
    searchCloseButtons.forEach(function(btn) {
      btn.addEventListener('click', closeSearch);
    });
    if (searchOverlay) {
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && searchOverlay.hasAttribute('data-search-open')) {
          closeSearch();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const carousel = document.querySelector('[data-gallery-carousel]');
    if (!carousel) return;

    const track = carousel.querySelector('[data-gallery-track]');
    const slides = carousel.querySelectorAll('[data-slide-index]');
    const prevButton = carousel.closest('.image-gallery').querySelector('[data-gallery-prev]');
    const nextButton = carousel.closest('.image-gallery').querySelector('[data-gallery-next]');

    if (!track || slides.length === 0) return;

    let currentIndex = 0;
    let autoPlayInterval = null;
    let touchStartX = 0;
    let touchEndX = 0;
    const autoPlayDelay = parseInt(carousel.dataset.autoPlayDelay || '5000', 10);
    const enableAutoPlay = carousel.dataset.enableAutoPlay === 'true';

    function updateCarousel() {
      if (slides.length === 0) return;
      const slide = slides[0];
      const gap = 16;
      const slideWidth = slide.offsetWidth + gap;
      const translateX = -currentIndex * slideWidth;
      track.style.transform = `translateX(${translateX}px)`;
    }

    function goToSlide(index) {
      const perPage = window.innerWidth >= 1024 ? 2 : (window.innerWidth >= 640 ? 2 : 1);
      const maxIndex = Math.max(0, slides.length - perPage);
      if (index < 0) {
        currentIndex = maxIndex;
      } else if (index > maxIndex) {
        currentIndex = 0;
      } else {
        currentIndex = index;
      }
      updateCarousel();
    }

    function nextSlide() {
      const perPage = window.innerWidth >= 1024 ? 2 : (window.innerWidth >= 640 ? 2 : 1);
      goToSlide(currentIndex + perPage);
      resetAutoPlay();
    }

    function prevSlide() {
      const perPage = window.innerWidth >= 1024 ? 2 : (window.innerWidth >= 640 ? 2 : 1);
      goToSlide(currentIndex - perPage);
      resetAutoPlay();
    }

    function startAutoPlay() {
      if (enableAutoPlay) {
        if (autoPlayInterval) clearInterval(autoPlayInterval);
        autoPlayInterval = setInterval(function() {
          nextSlide();
        }, autoPlayDelay);
      }
    }

    function stopAutoPlay() {
      if (autoPlayInterval) {
        clearInterval(autoPlayInterval);
        autoPlayInterval = null;
      }
    }

    function resetAutoPlay() {
      stopAutoPlay();
      startAutoPlay();
    }

    // Button controls
    if (prevButton) {
      prevButton.addEventListener('click', prevSlide);
    }

    if (nextButton) {
      nextButton.addEventListener('click', nextSlide);
    }

    // Touch/swipe support
    carousel.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
      stopAutoPlay();
    }, { passive: true });

    carousel.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
      startAutoPlay();
    }, { passive: true });

    function handleSwipe() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;
      
      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          // Swiped left - next
          nextSlide();
        } else {
          // Swiped right - previous
          prevSlide();
        }
      }
    }

    // Pause on hover (desktop only)
    if (window.matchMedia('(hover: hover)').matches) {
      carousel.addEventListener('mouseenter', stopAutoPlay);
      carousel.addEventListener('mouseleave', startAutoPlay);
    }

    // Initialize
    window.addEventListener('resize', updateCarousel);
    updateCarousel();
    startAutoPlay();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-gate"]) return;
  try {
    
  (function() {
    var overlay = document.getElementById('password-gate-overlay');
    if (!overlay) return;
    var form = document.getElementById('password-gate-form');
    var input = document.getElementById('password-gate-input');
    var errorEl = document.getElementById('password-gate-error');
    var key = overlay.getAttribute('data-unlock-key');
    var correctPassword = overlay.getAttribute('data-password') || '';

    if (!overlay || !form) return;

    if (sessionStorage.getItem(key) === 'true' && correctPassword) {
      overlay.setAttribute('data-unlocked', 'true');
      return;
    }

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      if (input.value === correctPassword) {
        sessionStorage.setItem(key, 'true');
        overlay.setAttribute('data-unlocked', 'true');
        errorEl.hidden = true;
      } else {
        errorEl.hidden = false;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    const gallery = document.querySelector('[data-product-gallery]');
    if (!gallery) return;

    const viewport = gallery.querySelector('[data-product-gallery-viewport]');
    const track = gallery.querySelector('[data-product-gallery-track]');
    const slides = gallery.querySelectorAll('[data-product-gallery-slide]');
    const prevBtn = gallery.querySelector('[data-product-gallery-prev]');
    const nextBtn = gallery.querySelector('[data-product-gallery-next]');
    const dots = gallery.querySelectorAll('[data-product-gallery-dot]');

    if (!track || slides.length <= 1) return;

    let currentIndex = 0;

    function updateCarousel() {
      if (slides.length === 0) return;
      var slideWidth = viewport ? viewport.offsetWidth : slides[0].offsetWidth;
      track.style.transform = 'translateX(-' + (currentIndex * slideWidth) + 'px)';
      dots.forEach(function(dot, i) {
        dot.classList.toggle('product-page__carousel-dot--active', i === currentIndex);
      });
    }

    function goTo(index) {
      currentIndex = Math.max(0, Math.min(index, slides.length - 1));
      updateCarousel();
    }

    function next() {
      goTo((currentIndex + 1) % slides.length);
    }

    function prev() {
      goTo(currentIndex <= 0 ? slides.length - 1 : currentIndex - 1);
    }

    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        var i = parseInt(dot.dataset.dotIndex, 10);
        if (!isNaN(i)) goTo(i);
      });
    });

    var touchStartX = 0;
    gallery.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].screenX;
    }, { passive: true });

    gallery.addEventListener('touchend', function(e) {
      var touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) next();
        else prev();
      }
    }, { passive: true });

    window.addEventListener('resize', updateCarousel);

    requestAnimationFrame(function() {
      requestAnimationFrame(updateCarousel);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-grid"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.querySelector('[data-section-type="testimonials-carousel"]');
    if (!section) return;
    const viewport = section.querySelector('[data-carousel-viewport]');
    const track = section.querySelector('[data-carousel-track]');
    const slides = section.querySelectorAll('[data-carousel-slide]');
    const prevBtn = section.querySelector('[data-carousel-prev]');
    const nextBtn = section.querySelector('[data-carousel-next]');
    if (!track || slides.length === 0) return;

    let index = 0;
    const total = slides.length;

    function getScrollAmount() {
      if (slides.length === 0) return 0;
      const card = slides[0];
      const gap = 16;
      const style = getComputedStyle(track);
      const gapVal = parseFloat(style.gap) || gap;
      return card.offsetWidth + gapVal;
    }

    function update() {
      const amount = getScrollAmount();
      track.style.transform = 'translateX(-' + (index * amount) + 'px)';
    }

    function prev() {
      index = index <= 0 ? total - 1 : index - 1;
      update();
    }

    function next() {
      index = index >= total - 1 ? 0 : index + 1;
      update();
    }

    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    let touchStartX = 0;
    let touchEndX = 0;
    if (viewport) {
      viewport.addEventListener('touchstart', function(e) { touchStartX = e.changedTouches[0].screenX; });
      viewport.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        if (touchStartX - touchEndX > 50) next();
        else if (touchEndX - touchStartX > 50) prev();
      });
    }

    window.addEventListener('resize', update);
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["transformation"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const carousel = document.querySelector('[data-transformation-carousel]');
    if (!carousel) return;

    const viewport = carousel.querySelector('[data-transformation-viewport]');
    const track = carousel.querySelector('[data-transformation-track]');
    const slides = carousel.querySelectorAll('[data-transformation-slide]');
    const prevBtn = carousel.querySelector('[data-transformation-prev]');
    const nextBtn = carousel.querySelector('[data-transformation-next]');
    const dots = carousel.querySelectorAll('[data-transformation-dot]');

    if (!track || slides.length <= 1) return;

    let currentIndex = 0;
    let autoPlayInterval = null;
    let touchStartX = 0;
    let touchEndX = 0;
    const autoPlay = carousel.dataset.autoPlay === 'true';
    const delay = parseInt(carousel.dataset.autoPlayDelay || '5000', 10);

    function updateCarousel() {
      const slideWidth = track.querySelector('[data-transformation-slide]').offsetWidth;
      track.style.transform = 'translateX(-' + (currentIndex * slideWidth) + 'px)';
      dots.forEach(function(dot, i) {
        dot.classList.toggle('transformation__dot--active', i === currentIndex);
      });
    }

    function goTo(index) {
      currentIndex = Math.max(0, Math.min(index, slides.length - 1));
      updateCarousel();
    }

    function next() {
      var nextIndex = (currentIndex + 1) % slides.length;
      goTo(nextIndex);
      resetAutoPlay();
    }

    function prev() {
      var prevIndex = currentIndex <= 0 ? slides.length - 1 : currentIndex - 1;
      goTo(prevIndex);
      resetAutoPlay();
    }

    function startAutoPlay() {
      if (autoPlay) {
        if (autoPlayInterval) clearInterval(autoPlayInterval);
        autoPlayInterval = setInterval(next, delay);
      }
    }

    function stopAutoPlay() {
      if (autoPlayInterval) {
        clearInterval(autoPlayInterval);
        autoPlayInterval = null;
      }
    }

    function resetAutoPlay() {
      stopAutoPlay();
      startAutoPlay();
    }

    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        var i = parseInt(dot.dataset.dotIndex, 10);
        if (!isNaN(i)) goTo(i);
        resetAutoPlay();
      });
    });

    carousel.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
      stopAutoPlay();
    }, { passive: true });

    carousel.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      var diff = touchStartX - touchEndX;
      if (Math.abs(diff) > 50) {
        if (diff > 0) next();
        else prev();
      }
      startAutoPlay();
    }, { passive: true });

    if (window.matchMedia('(hover: hover)').matches) {
      carousel.addEventListener('mouseenter', stopAutoPlay);
      carousel.addEventListener('mouseleave', startAutoPlay);
    }

    window.addEventListener('resize', updateCarousel);

    updateCarousel();
    startAutoPlay();
  })();

  } catch(e) { console.error(e); }
})();
})();
